import cn from "classnames";
import { ButtonVariants } from "./types";

const DEFAULT_BUTTON_CLASSNAME = "rounded-2xl";

export const BUTTON_STYLE_VARIANTS = {
  [ButtonVariants.PRIMARY]: cn(
    "bg-white-base px-5 py-4 font-medium leading-tight hover:shadow-md",
    DEFAULT_BUTTON_CLASSNAME
  ),
  [ButtonVariants.SECONDARY]: cn(
    "bg-white-base px-6 py-3.5 sm:px-8.5 sm:py-5 text-green-base text-14 sm:text-24 font-semibold",
    DEFAULT_BUTTON_CLASSNAME
  ),
  [ButtonVariants.OPACITY_GRAY]: cn(
    "bg-light-gray-transparent p-2 md:p-4.5 text-24 rounded-full md:rounded-2xl"
  ),
  [ButtonVariants.LIGHT_BLUE]: cn(
    "bg-blue-light px-5 py-4",
    DEFAULT_BUTTON_CLASSNAME
  ),
  [ButtonVariants.GREEN]: cn(
    "bg-green-light text-white-base text-18 md:text-24 font-extrabold p-2 md:p-4.5",
    DEFAULT_BUTTON_CLASSNAME
  ),
};
